import * as React from 'react';

function SvgTickSuccessYellow(props) {
  return (
    <svg width={112} height={64} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFF8DA" cx={56} cy={32} r={32} />
        <path
          d="M41.7 30.82l-.96.95c-.99 1-.99 2.6 0 3.59l8.92 8.9a2.53 2.53 0 003.6-.01l17.99-17.97c1-1 1-2.6 0-3.59l-.95-.95c-1-.99-2.6-.99-3.6 0L51.45 36.97 45.3 30.8c-1-.98-2.6-.98-3.6.01zm56.76.82c0-.7.55-1.27 1.23-1.27h10.72c.68 0 1.23.57 1.23 1.27 0 .7-.55 1.26-1.23 1.26H99.69c-.68 0-1.23-.56-1.23-1.26zm-2.1-8.02c0-.52.31-1 .81-1.2l7.21-2.7c.64-.25 1.34.1 1.58.75.23.66-.1 1.39-.74 1.63l-7.21 2.7c-.64.25-1.34-.1-1.57-.75a1.3 1.3 0 01-.08-.43zm0 16.04c0-.15.03-.3.08-.44.23-.65.93-1 1.57-.75l7.21 2.7c.64.25.97.97.74 1.63-.24.66-.94 1-1.58.76l-7.2-2.71c-.5-.19-.82-.68-.82-1.2zm-82.82-8.02c0-.7-.55-1.27-1.23-1.27H1.59c-.68 0-1.23.57-1.23 1.27 0 .7.55 1.26 1.23 1.26h10.72c.68 0 1.23-.56 1.23-1.26zm2.1-8.02c0-.52-.31-1-.81-1.2l-7.21-2.7c-.64-.25-1.34.1-1.58.75-.23.66.1 1.39.74 1.63l7.21 2.7c.64.25 1.34-.1 1.57-.75.05-.14.08-.29.08-.43zm0 16.04c0-.15-.03-.3-.08-.44-.23-.65-.93-1-1.57-.75l-7.21 2.7c-.64.25-.97.97-.74 1.63.24.66.94 1 1.58.76l7.2-2.71c.5-.19.82-.68.82-1.2z"
          fill="#FCCE01"
        />
      </g>
    </svg>
  );
}

export default SvgTickSuccessYellow;
